module.exports = __webpack_public_path__ + "images/img-18.39c59a28.jpg";